import * as Yup from 'yup'

export const addNewUserValidation = Yup.object({
  firstName: Yup.string().min(3).required('Please enter Full Name of the User'),
  contact: Yup.string().required('Please enter your mobile number or Email'),
})
